import { render } from "./GenrePicker.vue?vue&type=template&id=1dbbe981&scoped=true"
import script from "./GenrePicker.vue?vue&type=script&lang=js"
export * from "./GenrePicker.vue?vue&type=script&lang=js"

import "./GenrePicker.vue?vue&type=style&index=0&id=1dbbe981&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbbe981"]])

export default __exports__